import { render, staticRenderFns } from "./PendingFlag.vue?vue&type=template&id=2a3c2e82&"
import script from "./PendingFlag.vue?vue&type=script&lang=js&"
export * from "./PendingFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports